/**
 * Valor de face do produto em dinheiro, em reais.
 *
 * `cashValue` é a fonte da verdade. O fallback para `name` existe por causa dos
 * produtos legados, em que o nome do produto ERA o valor ("10", "10,50").
 * Retorna null quando não é resolvível.
 */
export const cashValueOfProduct = (product: any): number | null => {
  if (!product) { return null }

  if (product.cashValue !== null && product.cashValue !== undefined && product.cashValue !== '') {
    const fromColumn = Number(product.cashValue)
    return Number.isFinite(fromColumn) ? fromColumn : null
  }

  const legacyName = String(product.name ?? '').trim()
  if (legacyName === '') { return null }

  const fromLegacyName = Number(legacyName.replace(',', '.'))
  return Number.isFinite(fromLegacyName) ? fromLegacyName : null
}

/**
 * Cashback de VALOR LIVRE.
 *
 * Produto em dinheiro também sai com `isCashback = true` — é o que faz o PDV abater
 * reais em vez de percentual —, então a flag sozinha não distingue os dois. Só é
 * cashback livre quem tem a flag e nenhum produto vinculado.
 */
export const isFreeCashbackCoupon = (coupon: any): boolean =>
  Boolean(coupon?.isCashback) && !coupon?.productId && !coupon?.product

/** Cupom de produto em dinheiro (vale de valor fixo). */
export const isCashProductCoupon = (coupon: any): boolean =>
  Boolean(coupon?.product?.isCash)
